import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, Fragment as _Fragment, renderList as _renderList, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "error-msg-wrap" }
const _hoisted_2 = { class: "form-close" }
const _hoisted_3 = { class: "qc-item-wrap crm-item-wrap crm-item-wrap-bare" }
const _hoisted_4 = {
  key: 0,
  class: "crm-item-source"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 2,
  class: "crm-item-mirrors"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "item-row" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "item-row" }
const _hoisted_13 = {
  key: 0,
  class: "due-date-nudge"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "item-complete" }
const _hoisted_16 = ["checked"]
const _hoisted_17 = {
  key: 0,
  class: "item-hint"
}
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  key: 4,
  class: "item-hint",
  style: {"margin-top":"20px"}
}
const _hoisted_20 = { class: "item-private" }
const _hoisted_21 = {
  key: 0,
  class: "item-private-warn"
}
const _hoisted_22 = { key: 6 }
const _hoisted_23 = { class: "board-tip-tap" }
const _hoisted_24 = {
  key: 0,
  style: {"margin-top":"10px","display":"flex"}
}
const _hoisted_25 = { key: 7 }
const _hoisted_26 = {
  key: 0,
  class: "board-tip-tap"
}
const _hoisted_27 = { style: {"margin-top":"10px","display":"flex"} }
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "crm-item-section-head" }
const _hoisted_30 = {
  key: 0,
  class: "board-item-btns"
}
const _hoisted_31 = { class: "item-sent-text" }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = {
  key: 0,
  class: "item-sent-reply"
}
const _hoisted_34 = {
  key: 1,
  class: "item-hint"
}
const _hoisted_35 = {
  key: 10,
  class: "board-item-btns item-delete"
}
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { class: "crm-comment-section" }
const _hoisted_38 = { style: {"display":"flex"} }
const _hoisted_39 = {
  key: 0,
  class: "crm-comments"
}
const _hoisted_40 = ["onSubmit"]
const _hoisted_41 = { style: {"display":"flex"} }
const _hoisted_42 = {
  key: 1,
  class: "item-comment-text"
}
const _hoisted_43 = { class: "crm-comment-meta" }
const _hoisted_44 = { class: "crm-comment-date" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { class: "crm-item-section-head" }
const _hoisted_48 = { class: "board-item-btns" }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { class: "crm-item-file-list" }
const _hoisted_51 = ["href"]
const _hoisted_52 = ["href"]
const _hoisted_53 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_tip_tap = _resolveComponent("tip-tap")!
  const _component_send_task_picker = _resolveComponent("send-task-picker")!
  const _component_drop_file = _resolveComponent("drop-file")!
  const _component_confirm_delete = _resolveComponent("confirm-delete")!
  const _component_move_column_prompt = _resolveComponent("move-column-prompt")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["form-wrapper slide-up crm-form-wrapper", _ctx.formData.ID ? '' : 'crm-form-new']),
      style: _normalizeStyle(_ctx.formData.ID ? 'width:1100px' : '')
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          type: "button",
          class: "form-close-x",
          title: "Close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, "×")
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          (_ctx.fromMeeting)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_svg_icon, { icon: "twousers" }),
                _cache[37] || (_cache[37] = _createTextVNode("From meeting ", -1)),
                (_ctx.fromMeeting.CanOpen)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: { path: '/meetings', query: { meetingID: _ctx.formData.MeetingID, itemID: _ctx.formData.ID } }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.fromMeeting.Name), 1)
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : (_openBlock(), _createElementBlock("b", _hoisted_5, _toDisplayString(_ctx.fromMeeting.Name), 1))
              ]))
            : _createCommentVNode("", true),
          (_ctx.formData.ID)
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 1,
                type: "text",
                class: "h3-text-input",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.Name) = $event)),
                placeholder: "Enter Name",
                onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.fieldChange()))
              }, null, 544)), [
                [_vModelText, _ctx.formData.Name]
              ])
            : _createCommentVNode("", true),
          (_ctx.formData.ID && (_ctx.formData.HomeMeeting || _ctx.otherMirrorMeetings.length))
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_svg_icon, { icon: "copy" }),
                _createElementVNode("span", null, [
                  (_ctx.formData.HomeMeeting)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _cache[38] || (_cache[38] = _createTextVNode("Mirrored from ", -1)),
                        (!_ctx.fromMeeting)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('open-elsewhere', _ctx.formData.HomeMeeting)), ["prevent"]))
                            }, _toDisplayString(_ctx.formData.HomeMeeting.Name), 1))
                          : (_openBlock(), _createElementBlock("b", _hoisted_7, _toDisplayString(_ctx.formData.HomeMeeting.Name), 1))
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.otherMirrorMeetings.length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_ctx.formData.HomeMeeting ? ', also on ' : 'Also on '), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherMirrorMeetings, (m, i) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: m.ID
                          }, [
                            _createTextVNode(_toDisplayString(i ? ', ' : ''), 1),
                            (!_ctx.fromMeeting)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  onClick: _withModifiers(($event: any) => (_ctx.$emit('open-elsewhere', m)), ["prevent"])
                                }, _toDisplayString(m.Name), 9, _hoisted_8))
                              : (_openBlock(), _createElementBlock("b", _hoisted_9, _toDisplayString(m.Name), 1))
                          ], 64))
                        }), 128))
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.formData.ID)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _cache[39] || (_cache[39] = _createElementVNode("div", {
                  class: "crm-item-label",
                  style: {"margin-top":"0"}
                }, "Name", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  style: {"margin":"0"},
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.Name) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.formData.Name]
                ])
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", null, [
              _cache[41] || (_cache[41] = _createElementVNode("div", { class: "crm-item-label" }, "Priority", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.Priority) = $event)),
                onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.fieldChange()))
              }, [...(_cache[40] || (_cache[40] = [
                _createElementVNode("option", { value: null }, "No Priority", -1),
                _createElementVNode("option", { value: "high" }, "High", -1),
                _createElementVNode("option", { value: "med" }, "Medium", -1),
                _createElementVNode("option", { value: "low" }, "Low", -1)
              ]))], 544), [
                [_vModelSelect, _ctx.formData.Priority]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[43] || (_cache[43] = _createElementVNode("div", { class: "crm-item-label" }, "Assigned To", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.AssigneeEmployeeID) = $event)),
                onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.fieldChange()))
              }, [
                _cache[42] || (_cache[42] = _createElementVNode("option", { value: null }, "Unassigned", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employees, (emp) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: emp.ID,
                    value: emp.ID
                  }, _toDisplayString(emp.Name), 9, _hoisted_11))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.formData.AssigneeEmployeeID]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", null, [
              _cache[44] || (_cache[44] = _createElementVNode("div", { class: "crm-item-label" }, "Due Date", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "date",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.DueDate) = $event)),
                class: _normalizeClass(_ctx.dueDateNudge ? 'due-date-missing' : ''),
                onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.fieldChange()))
              }, null, 34), [
                [_vModelText, _ctx.formData.DueDate]
              ]),
              (_ctx.dueDateNudge)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, "No due date yet. We recommend setting one."))
                : _createCommentVNode("", true)
            ]),
            (_ctx.formData.ID)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _cache[46] || (_cache[46] = _createElementVNode("div", { class: "crm-item-label" }, "Status", -1)),
                  _createElementVNode("label", _hoisted_15, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      checked: _ctx.formData.Completed,
                      onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.toggleComplete($event)))
                    }, null, 40, _hoisted_16),
                    _createElementVNode("span", null, _toDisplayString(_ctx.formData.Completed ? 'Completed' : 'Mark completed'), 1)
                  ]),
                  (_ctx.formData.Completed && (_ctx.formData.CompletedByName || _ctx.formData.CompletedDate))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _cache[45] || (_cache[45] = _createTextVNode(" Completed", -1)),
                        (_ctx.formData.CompletedByName)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" by " + _toDisplayString(_ctx.formData.CompletedByName), 1)
                            ], 64))
                          : _createCommentVNode("", true),
                        (_ctx.formData.CompletedDate)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(" · " + _toDisplayString(_ctx.completedDateLabel), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_18))
          ]),
          (_ctx.canSetPrivate && (_ctx.onOthersTasks || _ctx.isMirrored) && !_ctx.formData.Private)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.isMirrored ? 'This item is mirrored onto other meetings' : 'This item is on someone else\'s task manager') + ", so it can't be made private. ", 1))
            : (_ctx.canSetPrivate)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                  _createElementVNode("label", _hoisted_20, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.Private) = $event)),
                      onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.fieldChange()))
                    }, null, 544), [
                      [_vModelCheckbox, _ctx.formData.Private]
                    ]),
                    _cache[47] || (_cache[47] = _createStaticVNode("<span class=\"item-private-track\" data-v-f2f10296><span class=\"item-private-knob\" data-v-f2f10296></span></span><span class=\"item-private-text\" data-v-f2f10296><span class=\"item-private-title\" data-v-f2f10296>Only visible to me</span><span class=\"item-hint\" data-v-f2f10296>Other attendees won&#39;t see this card on the board or in the meeting history.</span></span>", 2))
                  ]),
                  (_ctx.formData.Private && _ctx.formData.AssigneeEmployeeID && _ctx.formData.AssigneeEmployeeID != _ctx.$store.state.user.employeeID)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.assigneeName || 'The assignee') + " won't see this card while it's only visible to you. ", 1))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
          _cache[50] || (_cache[50] = _createElementVNode("div", { class: "crm-item-label" }, "Description", -1)),
          (_ctx.editDescription || !_ctx.formData.ID)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_tip_tap, {
                    modelValue: _ctx.formData.Description,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.Description) = $event)),
                    "hide-h3": true,
                    "hide-h4": true,
                    "hide-table": true
                  }, null, 8, ["modelValue"])
                ]),
                (_ctx.formData.ID)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("div", {
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.saveDescription())),
                        class: "btn",
                        style: {"margin":"0"}
                      }, "Save")
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                (_ctx.formData.Description)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      (_openBlock(), _createBlock(_component_tip_tap, {
                        key: _ctx.descriptionVersion,
                        "model-value": _ctx.formData.Description,
                        "read-only": true
                      }, null, 8, ["model-value"]))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", {
                    onClick: _cache[16] || (_cache[16] = () => { _ctx.editDescription = true; }),
                    class: "btn",
                    style: {"margin":"0"}
                  }, _toDisplayString(_ctx.formData.Description ? 'Edit' : 'Add a description'), 1)
                ])
              ])),
          (!_ctx.formData.ID)
            ? (_openBlock(), _createElementBlock("input", {
                key: 8,
                style: {"margin-top":"20px"},
                class: _normalizeClass(_ctx.disableButton ? 'disable-button' : ''),
                type: "submit",
                value: _ctx.dueDateNudge ? 'Submit Without Due Date' : 'Submit',
                onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.submit(false)))
              }, null, 10, _hoisted_28))
            : _createCommentVNode("", true),
          (_ctx.formData.ID && _ctx.sentLoaded && (_ctx.sentTo.length || _ctx.quickSendTarget || _ctx.canSendElsewhere))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                _createElementVNode("div", _hoisted_29, [
                  _cache[48] || (_cache[48] = _createElementVNode("h3", null, "Task manager", -1)),
                  (_ctx.quickSendTarget || _ctx.canSendElsewhere)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        (_ctx.quickSendTarget == 'me')
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass(_ctx.sending ? 'disable-button' : '')
                            }, [
                              _createElementVNode("span", {
                                onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.sendToTasks('me')))
                              }, "Send to my tasks")
                            ], 2))
                          : (_ctx.quickSendTarget == 'assignee')
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass(_ctx.sending ? 'disable-button' : '')
                              }, [
                                _createElementVNode("span", {
                                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.sendToTasks('assignee')))
                                }, "Send to " + _toDisplayString(_ctx.assigneeFirstName) + "'s tasks", 1)
                              ], 2))
                            : _createCommentVNode("", true),
                        (_ctx.canSendElsewhere)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 2,
                              class: _normalizeClass(_ctx.sending ? 'disable-button' : '')
                            }, [
                              _createElementVNode("span", {
                                onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.showSendPicker = !_ctx.showSendPicker))
                              }, "Send to...")
                            ], 2))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.showSendPicker)
                  ? (_openBlock(), _createBlock(_component_send_task_picker, {
                      key: 0,
                      "assignee-id": _ctx.formData.AssigneeEmployeeID,
                      "is-private": _ctx.formData.Private,
                      "sent-to": _ctx.sentTo,
                      busy: _ctx.sending || _ctx.mirroring,
                      "mirror-on": _ctx.canMirror ? _ctx.onMeetingIDs : null,
                      inventory: _ctx.canSendInventory,
                      onSend: _cache[21] || (_cache[21] = (target) => target.Target == 'meeting' ? _ctx.mirrorTo(target) : target.Target == 'inventory' ? _ctx.sendToInventory(target.Location) : _ctx.sendToTasks(target.Target, target)),
                      onCancel: _cache[22] || (_cache[22] = () => { _ctx.showSendPicker = false; })
                    }, null, 8, ["assignee-id", "is-private", "sent-to", "busy", "mirror-on", "inventory"]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sentTo, (s) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: s.CardID,
                    class: "item-sent"
                  }, [
                    _createElementVNode("span", _hoisted_31, [
                      _cache[49] || (_cache[49] = _createTextVNode("Sent to ", -1)),
                      (s.IsMine && !_ctx.fromMeeting)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: { path: '/deck/' + s.Slug, query: { openCard: s.CardID } }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(s.BoardName), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : (_openBlock(), _createElementBlock("b", _hoisted_32, _toDisplayString(s.BoardName), 1))
                    ]),
                    _createElementVNode("span", {
                      class: _normalizeClass(s.IsDone ? 'item-sent-col item-sent-col-done' : 'item-sent-col')
                    }, _toDisplayString(s.Column), 3),
                    (s.Reminder && s.Reminder.Status == 'declined')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                          _createTextVNode(_toDisplayString(_ctx.firstName(s.Reminder.RecipientName)) + " isn't doing this", 1),
                          (s.Reminder.DeclineReason)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(": \"" + _toDisplayString(s.Reminder.DeclineReason) + "\"", 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128)),
                (_ctx.quickSendTarget || _ctx.canSendElsewhere)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, "Adds this item to the top of their task manager. It stays the same item, so changes show in both places."))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.formData.ID && !_ctx.fromMeeting)
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", {
                    onClick: _cache[23] || (_cache[23] = () => { _ctx.showConfirmDelete = true; })
                  }, _toDisplayString(_ctx.formData.HomeMeeting ? 'Remove From This Board' : 'Delete'), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.formData.ID)
          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _cache[51] || (_cache[51] = _createElementVNode("div", { class: "crm-comments-header" }, [
                  _createElementVNode("b", null, "Comments")
                ], -1)),
                _createElementVNode("form", {
                  class: "crm-comment-form",
                  onSubmit: _cache[25] || (_cache[25] = _withModifiers(($event: any) => (_ctx.postComment()), ["prevent"]))
                }, [
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.newComment) = $event)),
                      placeholder: "Write a comment..."
                    }, null, 512), [
                      [_vModelText, _ctx.newComment]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("input", {
                      class: _normalizeClass(!_ctx.newComment.trim() || _ctx.postingComment ? 'disable-button btn' : 'btn'),
                      type: "submit",
                      value: "Save"
                    }, null, 2)
                  ])
                ], 32),
                (_ctx.commentsNewestFirst.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commentsNewestFirst, (c) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "crm-comment",
                          key: c.ID
                        }, [
                          (_ctx.editingCommentID == c.ID)
                            ? (_openBlock(), _createElementBlock("form", {
                                key: 0,
                                class: "crm-comment-form",
                                style: {"margin-bottom":"10px"},
                                onSubmit: _withModifiers(($event: any) => (_ctx.saveEditComment(c)), ["prevent"])
                              }, [
                                _createElementVNode("div", null, [
                                  _withDirectives(_createElementVNode("textarea", {
                                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.editCommentText) = $event))
                                  }, null, 512), [
                                    [_vModelText, _ctx.editCommentText]
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_41, [
                                  _createElementVNode("input", {
                                    class: _normalizeClass(_ctx.savingCommentEdit ? 'disable-button btn' : 'btn'),
                                    type: "submit",
                                    value: "Save"
                                  }, null, 2)
                                ])
                              ], 40, _hoisted_40))
                            : (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(c.Comment), 1)),
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("span", null, "- " + _toDisplayString(c.AuthorName || 'Unknown'), 1),
                            _createElementVNode("span", _hoisted_44, [
                              _createTextVNode(_toDisplayString(_ctx.formatCommentDate(c.CreateDate)), 1),
                              (c.UpdatedDate)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(" (edited)")
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]),
                            (_ctx.isMyComment(c))
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  onClick: _withModifiers(($event: any) => (_ctx.toggleEditComment(c)), ["prevent"])
                                }, _toDisplayString(_ctx.editingCommentID == c.ID ? 'Close' : 'Edit'), 9, _hoisted_45))
                              : _createCommentVNode("", true),
                            (_ctx.canDeleteComment(c))
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 1,
                                  class: "crm-x",
                                  title: "Delete comment",
                                  onClick: ($event: any) => (_ctx.commentPendingDelete = c)
                                }, [
                                  _createVNode(_component_svg_icon, {
                                    icon: "x",
                                    style: {"margin-left":"0"}
                                  })
                                ], 8, _hoisted_46))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_47, [
                _cache[52] || (_cache[52] = _createElementVNode("h3", null, "Files", -1)),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", {
                      onClick: _cache[27] || (_cache[27] = () => { _ctx.showAddFile = !_ctx.showAddFile; _ctx.showAddLink = false })
                    }, "Add PDF")
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", {
                      onClick: _cache[28] || (_cache[28] = () => { _ctx.showAddFile = false; _ctx.showAddLink = !_ctx.showAddLink })
                    }, "Add Link")
                  ])
                ])
              ]),
              (_ctx.showAddFile)
                ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                    _createVNode(_component_drop_file, {
                      "pdf-only": "",
                      "custom-text": "Drop a PDF",
                      onFileChange: _ctx.onFileChange,
                      style: {"margin-bottom":"20px"}
                    }, null, 8, ["onFileChange"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showAddLink)
                ? (_openBlock(), _createElementBlock("form", {
                    key: 1,
                    onSubmit: _cache[31] || (_cache[31] = _withModifiers(($event: any) => (_ctx.submitLink()), ["prevent"])),
                    style: {"margin-bottom":"20px"}
                  }, [
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        class: "input-slim",
                        style: {"margin":"0 0 10px"},
                        type: "text",
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.linkNameInput) = $event)),
                        placeholder: "Name"
                      }, null, 512), [
                        [_vModelText, _ctx.linkNameInput]
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        class: "input-slim",
                        style: {"margin":"0"},
                        type: "text",
                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.linkURLInput) = $event)),
                        placeholder: "URL"
                      }, null, 512), [
                        [_vModelText, _ctx.linkURLInput]
                      ])
                    ]),
                    _cache[53] || (_cache[53] = _createElementVNode("div", {
                      class: "inline-plus-input",
                      style: {"margin-top":"10px"}
                    }, [
                      _createElementVNode("button", {
                        style: {"margin":"0 !important","font-size":"12px"},
                        class: "btn"
                      }, [
                        _createElementVNode("span", null, "Add")
                      ])
                    ], -1))
                  ], 32))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_50, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: file.ID
                  }, [
                    (file.IsExternal)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: file.SpacesPath,
                          target: "_blank",
                          rel: "noopener"
                        }, _toDisplayString(file.Name), 9, _hoisted_51))
                      : (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          href: _ctx.$store.state.apiUrl + _ctx.$store.state.spacesUrl + file.SpacesPath,
                          target: "_blank"
                        }, _toDisplayString(file.Name), 9, _hoisted_52)),
                    _createElementVNode("span", {
                      class: "crm-x",
                      title: "Remove file",
                      onClick: ($event: any) => (_ctx.fileToDelete = file)
                    }, [
                      _createVNode(_component_svg_icon, { icon: "x" })
                    ], 8, _hoisted_53)
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ], 6),
    (_ctx.fileToDelete)
      ? (_openBlock(), _createBlock(_component_confirm_delete, {
          key: 0,
          onConfirm: _ctx.confirmFileDelete,
          onCancel: _cache[32] || (_cache[32] = () => { _ctx.fileToDelete = null; }),
          msg: "Are you sure you would like to remove this file?"
        }, null, 8, ["onConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.showConfirmDelete)
      ? (_openBlock(), _createBlock(_component_confirm_delete, {
          key: 1,
          onConfirm: _ctx.deleteItemCB,
          onCancel: _cache[33] || (_cache[33] = () => { _ctx.showConfirmDelete = false; }),
          msg: _ctx.deleteMessage
        }, null, 8, ["onConfirm", "msg"]))
      : _createCommentVNode("", true),
    (_ctx.commentPendingDelete)
      ? (_openBlock(), _createBlock(_component_confirm_delete, {
          key: 2,
          onConfirm: _ctx.deleteComment,
          onCancel: _cache[34] || (_cache[34] = () => { _ctx.commentPendingDelete = null; }),
          msg: "Are you sure you would like to delete this comment?"
        }, null, 8, ["onConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.movePrompt)
      ? (_openBlock(), _createBlock(_component_move_column_prompt, {
          key: 3,
          message: _ctx.movePrompt,
          columns: _ctx.columns,
          current: _ctx.formData.Column,
          "default-column": _ctx.moveColumn,
          onMove: _cache[35] || (_cache[35] = ($event: any) => (_ctx.moveToColumn($event))),
          onCancel: _cache[36] || (_cache[36] = ($event: any) => (_ctx.movePrompt = ''))
        }, null, 8, ["message", "columns", "current", "default-column"]))
      : _createCommentVNode("", true)
  ]))
}